import { Dayjs } from 'src/helpers/dayjs';
import { toDayjs } from 'src/helpers/dayjs';

import { IEdition } from 'src/interfaces/Edition';
import { IPageBlockDateFields } from 'src/interfaces/PageBlock';

export function resolvePageBlockDate(
  block: IPageBlockDateFields,
  currentEdition?: IEdition,
): Dayjs | undefined {
  if (block.useEditionDate === false && block.customDate) {
    return toDayjs(block.customDate) ?? undefined;
  }
  if (!currentEdition) return undefined;
  return toDayjs(currentEdition.date) ?? undefined;
}
